import { render, staticRenderFns } from "./coveShedAddress.vue?vue&type=template&id=0254a163&scoped=true&"
import script from "./coveShedAddress.vue?vue&type=script&lang=js&"
export * from "./coveShedAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254a163",
  null
  
)

export default component.exports